import React from "react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Dropdown, Message } from "semantic-ui-react";
import "./RemindersLayout.css";
import { committedOptions } from "../../../utils/consts";

const EventsFilter = (props) => {
  const handleFilterChange = (not, data) => {
    props.onChange();
    switch (data.name) {
      case "classyear":
        props.classYear(data.value);
        break;
      case "sport":
        props.sport(data.value);
        break;

      case "committed":
        props.commitment(data.value);
        break;

      default: {
      }
    }
  };

  return (
    <>
      <div className="AthleteSearchBanner main-filter-event">
        <h1>Reminders</h1>
        <div className="AthleteSearchFilterContainer">
          <div className="AthleteSearchFilter">
            {/* Class Year Dropdown */}
            {props.classYears && props.classYears.length > 0 ? (
              <Dropdown
                onChange={handleFilterChange}
                options={props.classYears}
                placeholder="Class Year"
                name="classyear"
                selection
                fluid
                clearable
              />
            ) : (
              <Dropdown placeholder="Class Year" selection>
                <Dropdown.Menu>
                  <Message
                    className="reminder-dropdown-empty"
                    info
                    header="Empty"
                    content="There's No Data Right Now"
                  />
                </Dropdown.Menu>
              </Dropdown>
            )}
            {/* Sports Dropdown */}
            {props.sports && props.sports.length > 0 ? (
              <Dropdown
                onChange={handleFilterChange}
                options={props.sports}
                placeholder="Sports"
                name="sport"
                selection
                fluid
                clearable
                search
              />
            ) : (
              <Dropdown placeholder="Sports" selection>
                <Dropdown.Menu>
                  <Message
                    className="reminder-dropdown-empty"
                    info
                    header="Empty"
                    content="There's No Data Right Now"
                  />
                </Dropdown.Menu>
              </Dropdown>
            )}
            {/* Committed Dropdown */}
            {props.classYears &&
            props.sports &&
            props.classYear.length > 0 &&
            props.sports.length > 0 ? (
              <Dropdown
                onChange={handleFilterChange}
                options={committedOptions}
                placeholder="Committed"
                name="committed"
                selection
                fluid
                clearable
              />
            ) : (
              <Dropdown placeholder="Committed" selection>
                <Dropdown.Menu>
                  <Message
                    className="reminder-dropdown-empty"
                    info
                    header="Empty"
                    content="There's No Data Right Now"
                  />
                </Dropdown.Menu>
              </Dropdown>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {};
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "adminAthletes",
      storeAs: "athletes",
    },
    {
      collection: "advocates",
    },
  ])
)(EventsFilter);
